import { TypographyElement, Row, Col } from 'UI'
import LearningPathCardRenderer from 'components/common/LearningPathCardRenderer'
import { chunk } from 'lodash'
import { useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import Text from './text.json'

const useStyles = createUseStyles(style)
const numberOfCardsPerRow = 2
const numberOfCardSkeletonToShow = 2

const ResponsiveList = ({ LearningPaths, loading, margin }) => {
  const { responsiveRow, responsiveCard } = useStyles({ margin })
  return (
    <Row className={responsiveRow}>
      <Col grid={12}>
        {LearningPaths.map((learningPath, index) => (
          <div key={index} className={responsiveCard}>
            <LearningPathCardRenderer
              learningPath={learningPath}
              loading={loading}
              isResponsive
            />
          </div>
        ))}
      </Col>
    </Row>
  )
}

const DesktopList = ({ LearningPaths, loading }) => {
  const theme = useTheme()
  const { learningPathCol } = useStyles({})
  const chunkedLearningPaths = chunk(LearningPaths, numberOfCardsPerRow)
  const [visibleRows, setVisibleRows] = useState(1)
  const visibleLearningPaths = chunkedLearningPaths.slice(0, visibleRows)
  return (
    <>
      {!loading && visibleLearningPaths.map((LearningPathsPart, partIndex) => (
        <Row key={partIndex}>
          {LearningPathsPart.map((LearningPathsPart, index) => (
            <Col className={learningPathCol} key={index} grid={6}>
              <LearningPathCardRenderer
                learningPath={LearningPathsPart}
                loading={loading}
              />
            </Col>
          ))}
        </Row>
      ))}
      {chunkedLearningPaths.length > visibleRows && !loading
        ? (
          <Row justify='center'>
            <Col grid={12}>
              <TypographyElement
                handleClick={() => setVisibleRows(visibleRows + 1)}
                cursor='pointer'
                color={theme.primary[0]}
                spacing='0 0 32px 0'
              >
                {Text.seeMore}
              </TypographyElement>
            </Col>
          </Row>
          )
        : null}
    </>
  )
}

export default ({ loading, LearningPaths = [], responsive, margin }) => {
  const LearningPathsToShow = loading ? [...LearningPaths, ...Array(numberOfCardSkeletonToShow).fill({ loading: true })] : LearningPaths
  if (!LearningPathsToShow.length) return null
  return (
    <>
      {!loading && <TypographyElement variant='heading2' spacing='0 0 24px 0' Component='h2'> {Text.title}</TypographyElement>}
      {responsive
        ? <ResponsiveList LearningPaths={LearningPathsToShow} loading={loading} margin={margin} />
        : <DesktopList LearningPaths={LearningPathsToShow} loading={loading} />}
    </>
  )
}
